enum UserGameState {
  DEFAULT = 'default',
  FIRSTGAME = 'first-game',
  USERFIRSTGAME = 'user-first-game',
  USERLOGGED = 'user-logged',
  USERLOGGEDLASTMINUTE = 'user-logged-last-minute',
  USERLOGGEDDRAW = 'user-logged-draw',
  USERINGAME = 'user-in-game',
  LASTMINUTE = 'last-minute',
  USERLASTMINUTE = 'user-last-minute',
  DRAW = 'draw',
  USERDRAW = 'user-draw',
  USERLOST = 'user-lost',
  USERALMOSTWIN = 'user-almost-win',
  USERWIN = 'user-win',
  USERCLAIMED = 'user-claimed',
  NOGAME = 'no-game',
}
export default UserGameState

